import { useCallback, useMemo } from "react";
import { noop } from "lodash";
import { useApolloClient } from "@apollo/client";

import Graph_QL, { GqlHook_Returns, StateDataObject } from "..";
import { useAppDispatch, useAppSelector } from "../../../Store";
import { filterByConnection } from "../filterByConnection";
import { gqlActions } from "../gqlData_Reducer";

import { TerminalTypeItem } from "./LocationFeedingSlices/terminalTypesSlice";
import { GET_TERMINAL_TYPES, TerminalTypesResponse } from "./GQLCalls/getTerminalTypesCall";

export const useTerminalTypes = (connection: Graph_QL.GQLCons): GqlHook_Returns<TerminalTypeItem, undefined> => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();

  const terminalsState = useAppSelector(({graphQlData:{domain}}) => domain.terminalTypes);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(terminalsState, Graph_QL.ToArr(connection)) as Record<string, TerminalTypeItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<TerminalTypeItem>)
  },[connection, terminalsState]);

  const getTerminalTypes = useCallback(async (specific?: Graph_QL.GQLCons) => {
    const usedConnection = specific?.connection ? specific.connection : connection.connection;
    try {
      client.query<TerminalTypesResponse>({query: GET_TERMINAL_TYPES, variables: {...usedConnection}})
        .then((e) => {
          if (e && e.data) {
            dispatch({type: String(gqlActions.domain.terminalTypes.maintained), payload: {con: connection?.connection, data: e.data.terminal.types}});
          }
        }).catch((error) => console.log(error));
    } catch (error) {
        console.log(error);
      }
    },[client, connection.connection, dispatch])


  return {call: getTerminalTypes,  fetchMore: noop, deleteEntries: noop, data: fullState, maintainEntries: noop}
} 

